import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Navbar from "../components/Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";

const Cancellation = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [accordion, setAccordion] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Dashboard" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="text-[18px0] mt-8 ml-4">Request Subscription Refund</div>

      <div className="bg-[#E0EDFF] w-[95%] ml-4 mt-8 flex items-center rounded-lg">
        <p className=" w-1 h-7 rounded-lg bg-[#2F80ED]"></p>
        <p className="text-[#2F80ED] text-[14px] p-2 ml-2">
          Refund will cancel of the current plan access from 2nd Feb 2024
        </p>
      </div>

      <div className="mt-20 config-width ">
        <div className="flex justify-center">
          <div className=" w-[50%] pt-2 px-4 rounded-lg bg-[#F2F2F2] cursor-pointer plan--card">
            <div
              className="flex justify-between items-center mb-2"
              onClick={() => setAccordion(!accordion)}
            >
              <p className="text-[16px]">
                Why do you want to cancel subscription?
              </p>
              <p>&#x2304;</p>
            </div>
            <hr />

            {accordion ? (
              <div className="my-4 bg-white p-1 rounded-lg">
                <div className="flex ml-2 my-2">
                  <input type="radio" />
                  <p className="text-[12px] ml-2">Selected Wrong Plan</p>
                </div>
                <div className="flex ml-2 my-4">
                  <input type="radio" />
                  <p className="text-[12px] ml-2">Difficult to use</p>
                </div>
                <div className="flex ml-2 my-4">
                  <input type="radio" />
                  <p className="text-[12px] ml-2">Limited Functionality</p>
                </div>
                <div className="flex ml-2 my-4">
                  <input type="radio" />
                  <p className="text-[12px] ml-2">Prices too high</p>
                </div>
                <div className="flex ml-2 my-4">
                  <input type="radio" />
                  <p className="text-[12px] ml-2">
                    Found a better alternative{" "}
                  </p>
                </div>
                <div className="flex ml-2 my-4">
                  <input type="radio" />
                  <p className="text-[12px] ml-2">Don't need it any more</p>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className="flex justify-center w-full">
          <div className="mt-4 w-[50%] plan--card">
            <p className="text-[14px]">Elaborate your reason </p>
            <input
              type="text"
              placeholder="Reason for cancellation"
              className="border w-full p-1 rounded-lg border-[#95C2FF] text-[16px]"
            />
            <div className="flex justify-center my-4">
              <button className="bg-[#2F80ED] font-bold text-white text-[14px] py-2 px-8 rounded-lg">
                Request Refund
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cancellation;
